import React from 'react';
import { useSelector } from 'react-redux';
import {
  FaPalette,
  FaCogs,
  FaDatabase,
  FaCloud,
  FaTools,
  FaArrowRight,
} from 'react-icons/fa';
import classes from './TechStack.module.scss';

const TechStack = () => {
  const techStack = useSelector((state) => state.portfolio.techStack);

  const sections = [
    {
      title: 'Frontend',
      description: 'Pixel-perfect interfaces & seamless user experiences',
      icon: <FaPalette />,
      techs: techStack.frontend,
      accent: '#6366f1',
    },
    {
      title: 'Backend',
      description: 'Robust APIs & scalable server architectures',
      icon: <FaCogs />,
      techs: techStack.backend,
      accent: '#8b5cf6',
    },
    {
      title: 'Database',
      description: 'Optimized data layers & real-time synchronization',
      icon: <FaDatabase />,
      techs: techStack.database,
      accent: '#3b82f6',
    },
    {
      title: 'Cloud & DevOps',
      description: 'Automated pipelines & infinite scalability',
      icon: <FaCloud />,
      techs: techStack.cloud,
      accent: '#06b6d4',
    },
    {
      title: 'Tools & Workflow',
      description: 'Streamlined collaboration & quality assurance',
      icon: <FaTools />,
      techs: techStack.tools,
      accent: '#10b981',
    },
  ];

  const totalTech = sections.reduce((sum, s) => sum + s.techs.length, 0);

  return (
    <section id="tech" className={classes.techStack}>
      <div className={classes.container}>
        {/* Header */}
        <div className={classes.header}>
          <span className={classes.badge}>Technology Stack</span>
          <h2 className={classes.title}>
            Built With{' '}
            <span className={classes.gradient}>Industry-Leading Tech</span>
          </h2>
          <p className={classes.subtitle}>
            We use {totalTech}+ battle-tested technologies across five key
            domains to deliver products that are fast, secure, and scalable.
          </p>
        </div>

        {/* Cards grid */}
        <div className={classes.grid}>
          {sections.map((section, index) => (
            <div
              key={index}
              className={classes.card}
              style={{ '--accent': section.accent }}
            >
              {/* Top row: icon + title + count */}
              <div className={classes.cardHead}>
                <div className={classes.iconBox}>{section.icon}</div>
                <div className={classes.cardMeta}>
                  <h3 className={classes.cardTitle}>{section.title}</h3>
                  <p className={classes.cardDesc}>{section.description}</p>
                </div>
                <span className={classes.techCount}>{section.techs.length}</span>
              </div>

              {/* Divider */}
              <div className={classes.divider} />

              {/* Tech chips */}
              <div className={classes.chips}>
                {section.techs.map((tech, i) => (
                  <span key={i} className={classes.chip}>
                    <span className={classes.chipDot} />
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className={classes.bottomCta}>
          <a href="#contact" className={classes.ctaLink}>
            <span>Need a custom tech recommendation?</span>
            <FaArrowRight className={classes.ctaArrow} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default TechStack;
